import React from "react";
import { Paper, Stack, Typography, Box, Skeleton } from "@mui/material";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";

import InfoButton from "../Clinical/InfoButton";
import CMStatCards from "./CMStatCards";
import TransitionsTable from "./TransitionsTable";

/**
 * Panel de Transition of Care — contenedor con header, stat cards y tabla de discharges.
 *
 * @param {{
 *   data: { stats: { avgLaceScore, highLaceCount, expiredCount }, discharges: Array },
 *   loading: boolean,
 *   onCreateTask: (row) => void,
 *   helpContent: object
 * }} props
 */
export default function PanelTransitions({ data, loading, onCreateTask, helpContent }) {
  if (loading) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Stack spacing={2}>
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="rectangular" animation="wave" height={300} sx={{ borderRadius: 2 }} />
        </Stack>
      </Paper>
    );
  }

  const hasDischarges = data?.discharges?.length > 0;

  const statItems = [
    {
      label: "Avg LACE+",
      value: data?.stats?.avgLaceScore,
      color: "#D97706",
      bgColor: "#FEF3C7",
    },
    {
      label: "High LACE",
      value: data?.stats?.highLaceCount,
      color: "#DC2626",
      bgColor: "#FEE2E2",
    },
    {
      label: "Expired",
      value: data?.stats?.expiredCount,
      color: "#991B1B",
      bgColor: "#FEE2E2",
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: 1.5,
              bgcolor: "#FEF3C7",
              color: "#D97706",
            }}
          >
            <TransferWithinAStationIcon sx={{ fontSize: 16 }} />
          </Box>
          <Typography variant="subtitle2" fontWeight={700}>
            Transition of Care
          </Typography>
          <InfoButton helpContent={helpContent} />
        </Stack>

        {/* Stat Cards */}
        <CMStatCards items={statItems} />

        {/* Table or Empty State */}
        {hasDischarges ? (
          <TransitionsTable discharges={data.discharges} onCreateTask={onCreateTask} />
        ) : (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: "italic", textAlign: "center", py: 4 }}
          >
            No recent discharges
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
